import React from 'react';
import Modal from '../../../../../../../components/Modal';
import { TransferInfoType } from '../types';
import UserInfoTransferTable from '../UserInfoTransferTable';
import { columns } from './columns';
import './UserInfoTransferModal.scss';

export interface IUserInfoTransferModalProps {
  transferInfo: TransferInfoType;
  onTransfer: () => void;
  onClose: () => void;
}

const UserInfoTransferModal = (props: IUserInfoTransferModalProps): JSX.Element => {
  const { transferInfo, onTransfer, onClose } = props;
  const { fromTransferUser, toTransferUser } = transferInfo;
  return (
    <Modal
      title="유저 계정 변경하기"
      isOpen={true}
      width={1200}
      isFooter={true}
      onOk={onTransfer}
      onClose={onClose}
      okText="변경하기"
    >
      <div className="user-infer-transfer-modal-table-title">
        <h2>유지할 회원 정보</h2>
        <p>기존 데이터를 유지하며 사용할 계정 정보입니다.</p>
      </div>
      <UserInfoTransferTable columns={columns(toTransferUser)} />
      <div className="user-infer-transfer-modal-table-title">
        <h2>동일한 번호로 가입된 회원정보</h2>
        <p>아래의 유저 계정이 유지할 회원 정보의 유저 계정으로 대체됩니다.</p>
      </div>
      <UserInfoTransferTable columns={columns(fromTransferUser)} />
    </Modal>
  );
};

export default UserInfoTransferModal;
